import React from 'react';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, FormattedDateTimeRange, Icon, SquareChip, TagsArray, Text } from 'app/main/components';
import { useSettings } from 'app/main/components/hooks';
import buttons from './CoursesButtons';

export default function CoursesListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	return (
		<GridListItem buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 600 ? 6 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.crss_warning_desc && (
								<Tooltip title={props.model.crss_warning_desc} placement="bottom" arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.crss_blocked_desc && (
								<Tooltip title={props.model.crss_blocked_desc} placement="bottom" arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'courses', uid: props.model.crss_uid }}
								// to={`/courses/details/${props.model.crss_uid}`}
							>
								{props.model.crss_title}
							</Text>
						</Grid>
						<Grid>
							{/* DURATION */}
							<SquareChip
								label={
									<FormattedDateTimeRange
										from={props.model.crss_d_start}
										to={props.model.crss_d_end}
									/>
								}
							/>
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 720 && (
					<Grid size={{ xs: props.width >= 960 ? 4 : props.width >= 600 ? 6 : 12 }}>
						<Grid container>
							<Grid size={12}>
								{/* SKILL */}
								<ButtonLink
									href={`/skills/details/${props.model.crss_skll_uid}`}
									icon="book"
									fallback={t('VIEW_ITEM_NO_SKILL')}
								>
									{props.model.skll_title}
								</ButtonLink>
							</Grid>
						</Grid>
					</Grid>
				)}
				{props.width >= 960 && (
					<Grid size={2} className="text-center">
						{/* TAGS */}
						<TagsArray tags={props.model.crss_tags} changeFilter={props.changeFilter} />
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
